import {z} from 'zod'

export const ProjectBudgets = z.object({
    id: z.string().min(1),
    year: z.number().int(),
    outpatientAmount: z.number().nonnegative(),
    houseAmount: z.number().nonnegative()
})
export type ProjectBudgets = z.infer<typeof ProjectBudgets>

export const ExternalCost = z.object({
    id: z.string().min(1),
    description: z.string().min(1),
    amount: z.number().nonnegative(),
    type: z.enum(['yearly', 'monthly']),
    year: z.number().int(),
    month: z.number().int().min(1).max(12),
    untilMonth: z.number().int().min(1).max(12).nullable(),
    untilYear: z.number().int().nullable()
})
export type ExternalCost = z.infer<typeof ExternalCost>

export const ExternalCostCode = z.enum(['AA1', 'AA2', 'AM', 'D1', 'D2'])
export type ExternalCostCode = z.infer<typeof ExternalCostCode>

export const AccessRate = z.object({
    id: z.string().min(1),
    code: ExternalCostCode,
    start: z.string().min(1),
    end: z.string().min(1).nullable(),
    rate: z.number().nonnegative()
})
export type AccessRate = z.infer<typeof AccessRate>
